import { render, staticRenderFns } from "./stus.vue?vue&type=template&id=7538fc82&scoped=true"
import script from "./stus.vue?vue&type=script&lang=js"
export * from "./stus.vue?vue&type=script&lang=js"
import style0 from "./stus.vue?vue&type=style&index=0&id=7538fc82&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7538fc82",
  null
  
)

export default component.exports